import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'yes-no',
    templateUrl: './yes-no.component.html',
    styleUrls: ['./yes-no.component.scss'],
    standalone: false
})
export class YesNoComponent implements OnInit {
  @Input() value?: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
